import ElementLocale from "element-ui/lib/locale";
import zhCN from "element-ui/lib/locale/lang/zh-CN";
import it from "element-ui/lib/locale/lang/it";
import { readFanyiFromStorage } from "./fanyiStorage";

// Element UI 中文内置文案自定义（覆盖官方 zh-CN 默认值）
const zhCNCustom = {
  ...zhCN,
  el: {
    ...zhCN.el,
    colorpicker: {
      ...zhCN.el.colorpicker,
      clear: "清除",
      confirm: "确认",
    },
    datepicker: {
      ...zhCN.el.datepicker,
      clear: "清除",
      confirm: "确认",
      startDate: "起始日期",
      startTime: "起始时间",
    },
    messagebox: {
      ...zhCN.el.messagebox,
      confirm: "确认",
    },
  },
};

// Element UI 意大利语内置文案自定义
const itCustom = {
  ...it,
  el: {
    ...it.el,
    colorpicker: {
      ...it.el.colorpicker,
      confirm: "Conferma",
    },
    datepicker: {
      ...it.el.datepicker,
      confirm: "Conferma",
      startDate: "Data di inizio",
      startTime: "Ora di inizio",
      endDate: "Data di fine",
      endTime: "Ora di fine",
    },
    messagebox: {
      ...it.el.messagebox,
      confirm: "Conferma",
      cancel: "Annulla",
    },
  },
};

/** 根据是否显示中文返回 Element UI 语言包 */
export function getElementLocale(isChinese) {
  return isChinese ? zhCNCustom : itCustom;
}

/** 切换 Element UI 内置文案（日期、分页、弹窗按钮等） */
export function applyElementLocale(isChinese) {
  ElementLocale.use(getElementLocale(isChinese));
}

/** 启动时按 localStorage 中的 fanyi 初始化 Element 语言 */
export function initElementLocaleFromStorage() {
  applyElementLocale(readFanyiFromStorage() === true);
}
